import {Box, Button, Stack, Typography} from '@mui/material'
import { FC, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { AppDispatch } from '../../../../../store'
import { CurrentUserSelector } from '../../../../../store/currentUser'
import { TechnologiesActions } from '../../../../../store/technologies'
import { ProjectsTable } from './ProjectTable'
import {ArrowForward} from "@mui/icons-material";
import {useNavigate} from "react-router-dom";

export const Projects: FC = () => {
    const navigate = useNavigate()
  const dispatch = useDispatch<AppDispatch>()

  const { _id } = useSelector(CurrentUserSelector.userDetail)

  useEffect(() => {
    if (_id) {
      dispatch(
        TechnologiesActions.fetchUserTechnologiesAsync({
          userId: _id,
          options: {
            params: { $counts: 'matchedGrants', $includes: 'matchedGrants', $limit: 5 },
          },
        }),
      )
    }
  }, [_id, dispatch])

  return (
    <Box my={3}>
      <Stack mb={1} direction="row" alignItems="center" justifyContent="space-between">
        <Typography fontSize="1rem" fontWeight={600} color="secondary">
          Projects
        </Typography>
          <Button
              variant="text"
              color="primary"
              onClick={() => navigate('/projects')}
              sx={{ px: 1.5, fontSize: '0.875rem', textTransform: 'none' }}
          >
              View all
          </Button>
      </Stack>

      <ProjectsTable />
    </Box>
  )
}
